var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-loading",on:{"click":_vm.onHandle}},[_c('img',{attrs:{"src":require("../../../static/images/loading.gif")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }